import { makeStyles } from "@fluentui/react-components";
import { dolphinTokens } from "../../../utils/Theme";

export const useMobileStyles = makeStyles({
    button: {
        textAlign: "left",
        justifyContent: "flex-start",
        margin: "0",
        minHeight: "44px",
        padding: "0 8px",
        borderRadius: "10px",
        display: "flex",
        alignItems: "center",
        fontSize: "15px",
        fontWeight: 600,
        color: dolphinTokens.colorDarkBlue,
        backgroundColor: "transparent",
    },
    dot: {
        width: "10px",
        height: "10px",
        borderRadius: "50%",
        flexShrink: 0,
        marginRight: "10px",
        boxShadow: "0 0 0 2px rgba(255, 255, 255, 0.5)",
    },
    dotBlue: { backgroundColor: dolphinTokens.colorLightBlue },
    dotLavender: { backgroundColor: dolphinTokens.colorSkyLavender },
    dotMint: { backgroundColor: dolphinTokens.colorMintGreen },
    dotPeach: { backgroundColor: dolphinTokens.colorPeachOrange },
    dotSunflower: { backgroundColor: dolphinTokens.colorSunflowerYellow },
    accordion: {
        width: "100%",
    },
    accordionHeader: {
        padding: 0,
        margin: 0,
        width: "100%",
        transitionProperty: "background-color, color",
        transitionDuration: "150ms",

        "& button": {
            paddingLeft: "8px",
            textAlign: "left",
            justifyContent: "flex-start",
            width: "100%",
            minHeight: "44px",
            display: "flex",
            alignItems: "center",
            marginRight: "auto",
            fontSize: "15px",
            fontWeight: 600,
            color: dolphinTokens.colorDarkBlue,
            backgroundColor: "transparent",
        },
        "& button:hover": { backgroundColor: dolphinTokens.colorLightBlue20, color: dolphinTokens.colorDarkBlue },
        "& button:hover:active": { backgroundColor: dolphinTokens.colorLightBlue20, color: dolphinTokens.colorDarkBlue },
        "& button[data-fui-focus-visible]": { backgroundColor: dolphinTokens.colorLightBlue20 },
    },
    accordionHeaderAccentBlue: {
        "& button[aria-expanded='true']": { backgroundColor: dolphinTokens.colorLightBlue, color: dolphinTokens.colorNeutralForegroundOnBrand },
        "& button[aria-expanded='true']:hover": { backgroundColor: dolphinTokens.colorLightBlue, color: dolphinTokens.colorNeutralForegroundOnBrand },
    },
    accordionHeaderAccentLavender: {
        "& button[aria-expanded='true']": { backgroundColor: dolphinTokens.colorSkyLavender, color: dolphinTokens.colorDarkBlue },
        "& button[aria-expanded='true']:hover": { backgroundColor: dolphinTokens.colorSkyLavender, color: dolphinTokens.colorDarkBlue },
    },
    accordionHeaderAccentMint: {
        "& button[aria-expanded='true']": { backgroundColor: dolphinTokens.colorMintGreen, color: dolphinTokens.colorDarkBlue },
        "& button[aria-expanded='true']:hover": { backgroundColor: dolphinTokens.colorMintGreen, color: dolphinTokens.colorDarkBlue },
    },
    accordionHeaderAccentPeach: {
        "& button[aria-expanded='true']": { backgroundColor: dolphinTokens.colorPeachOrange, color: dolphinTokens.colorDarkBlue },
        "& button[aria-expanded='true']:hover": { backgroundColor: dolphinTokens.colorPeachOrange, color: dolphinTokens.colorDarkBlue },
    },
    accordionHeaderAccentSunflower: {
        "& button[aria-expanded='true']": { backgroundColor: dolphinTokens.colorSunflowerYellow, color: dolphinTokens.colorDarkBlue },
        "& button[aria-expanded='true']:hover": { backgroundColor: dolphinTokens.colorSunflowerYellow, color: dolphinTokens.colorDarkBlue },
    },
    sectionHeader: {
        display: "block",
        color: dolphinTokens.colorDarkBlue60,
        fontSize: "0.75rem",
        fontWeight: 700,
        textTransform: "uppercase",
        letterSpacing: "0.02em",
        marginTop: "18px",
        marginBottom: "4px",
        paddingLeft: "8px",
    },
    link: {
        display: "flex",
        alignItems: "center",
        minHeight: "40px",
        padding: "0 8px",
        marginTop: "2px",
        borderRadius: "10px",
        fontSize: "14.5px",
        color: dolphinTokens.colorDarkBlue,
        textDecorationLine: "none",
        ":hover": { backgroundColor: dolphinTokens.colorLightBlue20, color: dolphinTokens.colorLightBlue },
        ":hover:active": { backgroundColor: dolphinTokens.colorLightBlue20, color: dolphinTokens.colorLightBlue },
        "[data-fui-focus-visible]": { backgroundColor: dolphinTokens.colorLightBlue20 },
    },
});